export default __webpack_public_path__ + "static/media/litho-demo-blog-post-layout-03.e649907e.jpg";